<nz-collapse nzGhost>
    <nz-collapse-panel [nzHeader]="pfHeader" [nzActive]="active">
        <nz-content>
            <ng-content></ng-content>
        </nz-content>
    </nz-collapse-panel>
</nz-collapse>
